// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__28pFM","gfeWrapper":"CalendarEvent_gfeWrapper__3p_83"};